import React from "react";
import { Typography, Row, Col, Collapse, Space } from "antd";
import {
  QuestionCircleOutlined,
  LineChartOutlined,
  BookOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { theme } from "../../../utils/theme";
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const faqItems = [
  {
    icon: <QuestionCircleOutlined />,
    title: "Hangi bölümde seni ne bekliyor?",
    color: theme.faqColor,
    content: "Bu bölümde kariyerinizle ilgili beklentiler açıklanmaktadır.",
  },
  {
    icon: <LineChartOutlined />,
    title: "Pozisyonların iş tanımları neler?",
    color: theme.faqColor,
    content:
      "Çeşitli pozisyonların detaylı iş tanımları burada yer almaktadır.",
  },
  {
    icon: <BookOutlined />,
    title: "Meslek grupları ne kadar maaş alıyor?",
    color: theme.faqColor,
    content:
      "Farklı meslek gruplarının ortalama maaş bilgileri bu bölümde sunulmaktadır.",
  },
  {
    icon: <FileSearchOutlined />,
    title: "Sana özel CV şablonları burada!",
    color: theme.faqColor,
    content: "Kişiselleştirilmiş CV şablonlarına buradan ulaşabilirsiniz.",
  },
];

const FAQComponent = () => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <div style={{ width: "90%", margin: "auto" }}>
      <Row gutter={[24, 24]} style={{ padding: "24px" }}>
        <Col span={isSmallScreen ? 24 : 14}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Title level={2}>KARİYERİNİ PLANLA</Title>
            <Paragraph>
              Kariyerini planlamaya hazır mısın? Üniversite tercihinden itibaren
              kariyer yolculuğunun her adımını titizlikle planlayabileceğin
              içerikleri senin için bir araya getirdik. Merak ettiğin tüm
              sorulara yanıt bulacak, iş fırsatlarını keşfedeceksin!
            </Paragraph>
            <Collapse
              bordered={false}
              expandIconPosition="end"
              style={{ background: "white" }}>
              {faqItems.map((item, index) => (
                <Panel
                  key={index}
                  header={
                    <Space>
                      {React.cloneElement(item.icon, {
                        style: { fontSize: "24px", color: item.color },
                      })}
                      <span
                        style={{
                          color: item.color,
                          fontWeight:
                            item.color === "#722ED1" ? "bold" : "normal",
                        }}>
                        {item.title}
                      </span>
                    </Space>
                  }
                  style={{
                    marginBottom: 16,
                    paddingLeft: 16,
                    background: "white",
                    borderRadius: 4,
                    border: "1px solid #f0f0f0",
                    borderLeft: `4px solid ${item.color}`,
                  }}>
                  <p>{item.content}</p>
                </Panel>
              ))}
            </Collapse>
          </Space>
        </Col>
        <Col span={isSmallScreen ? 0 : 10}>
          {!isSmallScreen ? (
            <img
              src="https://personelika.com/wp-content/uploads/2024/04/bg.webp"
              alt="Career woman"
              style={{
                position: "absolute",
                width: "80%",
                height: "80%",
                objectFit: "contain",
                bottom: 0,
                left: "10%",
              }}
            />
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default FAQComponent;
